const SearchBar = {
  data() {
    return {
      inputValue: this.setInputValue !== '' || this.setInputValue !== "undefined" || this.setInputValue !== null ? this.setInputValue : '',
      isActive: this.setActive
    }
  },
  props: [
    'setInputValue',
    'setActive'
  ],
  watch: {
    setActive(newValue) {
      this.isActive = newValue
    }
  },
  updated () {
    if (this.isActive) {
      this.$refs.search_bar_input.focus()
    }
  }
}

export default SearchBar
